export default{
    namespaced:true,
    state:{
        isCollapse:false,
    },
    mutations:{
        changeCollapse(state){
            // 取反
            state.isCollapse = !state.isCollapse
        }
    }
}